<form [formGroup]="formGroup" class="flex flex-row flex-wrap gap-4">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Date to filter by</mat-label>
    <mat-select formControlName="queryableTimestamp" required>
      @for (
        queryableTimestamp of queryableTimestamps();
        track queryableTimestamp.property.metadata.id
      ) {
        <mat-option
          matTooltipPosition="right"
          matTooltipShowDelay="300"
          [value]="queryableTimestamp.property.metadata.id"
          [matTooltip]="queryableTimestamp.property.metadata.summary"
          [matTooltipDisabled]="!queryableTimestamp.property.metadata.summary"
        >
          {{ queryableTimestamp.property.metadata.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <pt-date-range-form
    [useRangePicker]="true"
    [from]="formGroup.value.from"
    [to]="formGroup.value.to"
    (changed)="setDateRange($event)"
  />
</form>
